const ICON_TABLE = ({ color = "#000", strokeWidth = 3, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    fill="none"
    {...props}
  >
    <path
      className="path_svg"
      stroke={color}
      strokeWidth={strokeWidth}
      d="M8.202 19.4h33.596M8.202 30.6h33.596M19.4 19.4V41.8M30.6 19.4V41.8"
    />
    <path
      className="path_svg"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M38.142 8.202H11.858a3.657 3.657 0 0 0-3.656 3.656v26.284a3.656 3.656 0 0 0 3.656 3.656h26.284a3.657 3.657 0 0 0 3.656-3.656V11.858a3.657 3.657 0 0 0-3.656-3.656z"
    />
  </svg>
);

export default ICON_TABLE;
